var _g, _path, _g2, _g3, _g4, _g5, _path2, _g6, _g7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorial2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 303,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_2_svg__filter0_ii_104_85)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 72.719,
    width: 392,
    height: 67.073,
    rx: 5.073,
    fill: "#A24FB5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C778D8",
    stroke: "#BE77CE",
    strokeWidth: 1.268,
    d: "M10.783 83.477h370.434v45.556H10.783z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_2_svg__filter1_d_104_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.136 114.233l-.02-8.523-4.18 7.021h-1.482l-4.16-6.838v8.34h-3.084v-14.205h2.719l5.317 8.827 5.235-8.827h2.699l.04 14.205h-3.084zm12.765.243c-2.029 0-3.612-.561-4.748-1.684-1.123-1.123-1.684-2.726-1.684-4.809v-7.955h3.287v7.833c0 2.543 1.055 3.815 3.165 3.815 1.029 0 1.813-.304 2.354-.913.541-.622.812-1.59.812-2.902v-7.833h3.247v7.955c0 2.083-.568 3.686-1.705 4.809-1.123 1.123-2.699 1.684-4.728 1.684zm9.681-14.448h3.287v11.526h7.123v2.679h-10.41v-14.205zm13.861 2.679h-4.545v-2.679h12.378v2.679h-4.545v11.526h-3.288v-11.526zm9.602-2.679h3.287v14.205h-3.287v-14.205zm12.806 0c1.258 0 2.347.21 3.267.629.934.42 1.651 1.015 2.151 1.786.501.771.751 1.684.751 2.74 0 1.041-.25 1.954-.751 2.739-.5.771-1.217 1.366-2.151 1.786-.92.406-2.009.608-3.267.608h-2.861v3.917h-3.287v-14.205h6.148zm-.182 7.61c.987 0 1.738-.21 2.252-.629.514-.433.771-1.042.771-1.826 0-.799-.257-1.407-.771-1.827-.514-.433-1.265-.649-2.252-.649h-2.679v4.931h2.679zm8.698-7.61h3.287v11.526h7.123v2.679h-10.41v-14.205zm21.72 11.161h-6.595l-1.258 3.044h-3.368l6.331-14.205h3.246l6.352 14.205h-3.45l-1.258-3.044zm-1.035-2.496l-2.252-5.438-2.253 5.438h4.505zm13.163.507v5.033h-3.288v-5.073l-5.499-9.132h3.49l3.795 6.311 3.795-6.311h3.226l-5.519 9.172zm17.754 2.395v2.638h-10.998v-14.205h10.734v2.638h-7.467v3.085h6.595v2.557h-6.595v3.287h7.731zm11.666 2.638l-2.74-3.957h-3.023v3.957h-3.288v-14.205h6.149c1.258 0 2.347.21 3.267.629.933.42 1.65 1.015 2.151 1.786.5.771.751 1.684.751 2.74 0 1.055-.257 1.968-.771 2.739-.501.758-1.218 1.339-2.151 1.745l3.185 4.566h-3.53zm-.061-9.05c0-.799-.257-1.407-.771-1.827-.514-.433-1.265-.649-2.253-.649h-2.678v4.951h2.678c.988 0 1.739-.216 2.253-.649.514-.433.771-1.042.771-1.826z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_2_svg__filter2_ii_104_85)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.584,
    width: 392,
    height: 67.073,
    rx: 5.073,
    fill: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#E1E1E1",
    strokeWidth: 1.268,
    d: "M10.783 11.342h370.434v45.556H10.783z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_2_svg__filter3_df_104_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.04 37.25a8.208 8.208 0 01-2.39-.35c-.761-.233-1.364-.543-1.811-.928l.685-1.537c.436.344.969.629 1.598.852a6.03 6.03 0 001.918.32c.791 0 1.379-.127 1.765-.381.396-.254.593-.588.593-1.005a.94.94 0 00-.334-.745 2.162 2.162 0 00-.822-.472 18.606 18.606 0 00-1.37-.38c-.812-.193-1.471-.386-1.978-.579a3.351 3.351 0 01-1.294-.898c-.355-.416-.533-.974-.533-1.674 0-.588.158-1.12.472-1.598.325-.487.807-.872 1.446-1.156.649-.285 1.441-.427 2.374-.427.649 0 1.289.082 1.918.244.629.162 1.172.396 1.628.7l-.624 1.537a6.165 6.165 0 00-1.461-.624 5.459 5.459 0 00-1.476-.213c-.781 0-1.365.132-1.75.396-.376.264-.563.614-.563 1.05a.96.96 0 00.319.746c.223.192.502.345.837.456.335.112.792.239 1.37.38.791.183 1.441.376 1.948.579a3.21 3.21 0 011.294.898c.365.406.547.954.547 1.644 0 .588-.162 1.12-.487 1.597-.314.477-.796.858-1.445 1.142-.65.284-1.441.426-2.374.426zm6.268-10.805h1.979v10.653h-1.979V26.445zm14.326 0v10.653h-1.628l-5.874-7.214v7.214h-1.964V26.445h1.629l5.874 7.213v-7.213h1.963zm10.13 5.204h1.872v4.247a5.95 5.95 0 01-1.918 1.004c-.73.233-1.481.35-2.252.35-1.086 0-2.065-.233-2.938-.7a5.314 5.314 0 01-2.054-1.963c-.497-.832-.746-1.77-.746-2.816 0-1.045.249-1.983.746-2.815a5.205 5.205 0 012.054-1.948c.883-.477 1.872-.715 2.968-.715.893 0 1.705.147 2.435.44a4.782 4.782 0 011.842 1.294l-1.248 1.218c-.812-.812-1.791-1.218-2.938-1.218-.75 0-1.42.158-2.008.472a3.504 3.504 0 00-1.37 1.324c-.325.568-.487 1.218-.487 1.948 0 .71.162 1.35.487 1.918a3.614 3.614 0 001.37 1.34c.588.324 1.253.486 1.993.486.832 0 1.563-.182 2.192-.548V31.65zm4.481-5.204h1.979v8.979h5.57v1.674h-7.549V26.445zm17.101 8.994v1.659h-7.99V26.445h7.777v1.659h-5.799v2.77h5.144v1.628h-5.144v2.937h6.012zm10.794-8.994c.923 0 1.725.152 2.405.456.69.305 1.217.74 1.583 1.309.365.568.547 1.243.547 2.024 0 .771-.182 1.446-.547 2.024-.366.569-.893 1.005-1.583 1.31-.68.303-1.482.456-2.405.456h-2.404v3.074h-1.979V26.445h4.383zm-.091 5.905c.862 0 1.517-.183 1.963-.548.447-.366.67-.888.67-1.568s-.223-1.202-.67-1.567c-.446-.366-1.101-.548-1.963-.548h-2.313v4.23h2.313zm6.602-5.905h1.979v8.979h5.57v1.674h-7.549V26.445zm16.094 8.187h-5.326l-1.05 2.466h-2.04l4.794-10.653h1.948l4.81 10.653h-2.07l-1.066-2.466zm-.654-1.552l-2.009-4.657-1.994 4.657h4.003zm9.101.259v3.759h-1.978v-3.729l-4.185-6.924h2.115l3.12 5.19 3.15-5.19h1.948l-4.17 6.894zm13.307 2.1v1.659h-7.99V26.445h7.777v1.659h-5.798v2.77h5.144v1.628h-5.144v2.937h6.011zm9.176 1.659l-2.176-3.12c-.091.01-.228.015-.411.015h-2.405v3.105h-1.978V26.445h4.383c.923 0 1.725.152 2.405.456.689.305 1.217.74 1.582 1.309.366.568.548 1.243.548 2.024 0 .802-.198 1.492-.593 2.07-.386.578-.944 1.01-1.674 1.293l2.45 3.5h-2.131zm-.045-6.864c0-.68-.224-1.202-.67-1.567-.447-.366-1.101-.548-1.963-.548h-2.314v4.246h2.314c.862 0 1.516-.183 1.963-.548.446-.375.67-.903.67-1.583z",
    fill: "#F8F8F8"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_2_svg__filter4_ii_104_85)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 144.854,
    width: 392,
    height: 67.073,
    rx: 5.073,
    fill: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#E1E1E1",
    strokeWidth: 1.268,
    d: "M10.783 155.612h370.434v45.556H10.783z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_2_svg__filter5_df_104_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.018 181.367l-.015-7.061-3.501 5.844h-.882l-3.501-5.753v6.97h-1.887v-10.653h1.629l4.231 7.062 4.154-7.062h1.629l.015 10.653h-1.872zm4.75-10.653h1.978v10.653h-1.978v-10.653zm14.326 0v10.653h-1.629l-5.874-7.213v7.213h-1.964v-10.653h1.629l5.874 7.214v-7.214h1.964zm10.844 8.995v1.658h-7.99v-10.653h7.777v1.659h-5.798v2.77h5.144v1.628h-5.144v2.938h6.011zm7.092 1.811c-1.075 0-2.049-.234-2.922-.7a5.345 5.345 0 01-2.039-1.964c-.487-.832-.731-1.77-.731-2.815s.249-1.984.746-2.816a5.233 5.233 0 012.039-1.948c.873-.477 1.847-.715 2.922-.715.873 0 1.669.152 2.39.457.72.304 1.329.745 1.826 1.324l-1.278 1.202c-.771-.832-1.72-1.248-2.846-1.248-.731 0-1.385.162-1.964.487a3.402 3.402 0 00-1.354 1.324c-.325.568-.487 1.212-.487 1.933 0 .72.162 1.364.487 1.933a3.513 3.513 0 001.354 1.339c.579.314 1.233.472 1.964.472 1.126 0 2.075-.421 2.846-1.264l1.278 1.218a4.848 4.848 0 01-1.841 1.324c-.721.304-1.517.457-2.39.457zm13.097-.153l-2.176-3.119c-.092.01-.229.015-.411.015h-2.405v3.104h-1.978v-10.653h4.383c.923 0 1.725.152 2.404.457.69.304 1.218.74 1.583 1.309.365.568.548 1.242.548 2.024 0 .801-.198 1.491-.594 2.069-.385.579-.943 1.01-1.674 1.294l2.451 3.5h-2.131zm-.046-6.863c0-.68-.223-1.203-.669-1.568-.447-.365-1.101-.548-1.964-.548h-2.313v4.246h2.313c.863 0 1.517-.182 1.964-.548.446-.375.669-.903.669-1.582zm11.117 4.398h-5.327l-1.05 2.465h-2.039l4.794-10.653h1.948l4.809 10.653h-2.07l-1.065-2.465zm-.654-1.552l-2.009-4.657-1.994 4.657h4.003zm7.122-4.977v3.242h5.144v1.674h-5.144v4.078h-1.978v-10.653h7.777v1.659h-5.799zm9.947.015h-3.53v-1.674h9.04v1.674h-3.531v8.979h-1.979v-8.979zm18.171 8.979l-2.177-3.119a4.1 4.1 0 01-.41.015h-2.405v3.104h-1.978v-10.653h4.383c.923 0 1.724.152 2.404.457.69.304 1.218.74 1.583 1.309.365.568.548 1.242.548 2.024 0 .801-.198 1.491-.594 2.069-.385.579-.943 1.01-1.674 1.294l2.45 3.5h-2.13zm-.046-6.863c0-.68-.223-1.203-.67-1.568-.446-.365-1.1-.548-1.963-.548h-2.313v4.246h2.313c.863 0 1.517-.182 1.963-.548.447-.375.67-.903.67-1.582zm12.197 5.205v1.658h-7.99v-10.653h7.777v1.659h-5.798v2.77h5.144v1.628h-5.144v2.938h6.011zm9.115-.807h-5.326l-1.051 2.465h-2.039l4.794-10.653h1.948l4.809 10.653h-2.069l-1.066-2.465zm-.654-1.552l-2.009-4.657-1.994 4.657h4.003zm5.144-6.636h1.979v8.979h5.57v1.674h-7.549v-10.653zm18.897 10.653l-.016-7.061-3.5 5.844h-.883l-3.5-5.753v6.97h-1.887v-10.653h1.628l4.231 7.062 4.155-7.062h1.628l.015 10.653h-1.871zm8.051.153a8.217 8.217 0 01-2.389-.35c-.761-.234-1.365-.543-1.811-.929l.685-1.537c.436.345.969.629 1.598.852.639.213 1.278.32 1.917.32.792 0 1.38-.127 1.766-.38.396-.254.593-.589.593-1.005a.941.941 0 00-.334-.746 2.151 2.151 0 00-.822-.471 18.32 18.32 0 00-1.37-.381c-.812-.193-1.471-.385-1.978-.578a3.344 3.344 0 01-1.294-.898c-.355-.416-.533-.974-.533-1.674 0-.589.158-1.121.472-1.598.325-.487.807-.873 1.446-1.157.649-.284 1.441-.426 2.374-.426.649 0 1.289.081 1.918.243.629.163 1.172.396 1.628.701l-.624 1.537a6.162 6.162 0 00-1.461-.624 5.463 5.463 0 00-1.476-.213c-.781 0-1.365.132-1.75.395-.376.264-.563.614-.563 1.05a.96.96 0 00.319.746c.223.193.502.345.837.457a18.9 18.9 0 001.37.38c.791.183 1.441.376 1.948.579.507.192.938.492 1.294.897.365.406.547.954.547 1.644 0 .589-.162 1.121-.487 1.598-.314.477-.796.857-1.445 1.141-.65.285-1.441.427-2.375.427z",
    fill: "#F8F8F8"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_2_svg__filter6_ii_104_85)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.537,
    y: 235.902,
    width: 193.463,
    height: 67.073,
    rx: 5.073,
    fill: "#A24FB5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C778D8",
    stroke: "#BE77CE",
    strokeWidth: 1.268,
    d: "M209.32 246.66h171.897v45.556H209.32z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_2_svg__filter7_d_104_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.404 274.372h-6.595l-1.258 3.044h-3.369l6.332-14.204h3.246l6.352 14.204h-3.45l-1.258-3.044zm-1.035-2.496l-2.252-5.438-2.253 5.438h4.505zm7.216-8.664h6.453c1.542 0 2.902.297 4.079.893 1.19.581 2.11 1.406 2.76 2.475.662 1.069.994 2.313.994 3.734 0 1.42-.332 2.665-.994 3.734-.65 1.068-1.57 1.9-2.76 2.495-1.177.582-2.537.873-4.079.873h-6.453v-14.204zm6.291 11.505c1.42 0 2.55-.392 3.389-1.177.852-.798 1.278-1.873 1.278-3.226s-.426-2.422-1.278-3.206c-.839-.798-1.969-1.198-3.389-1.198h-3.003v8.807h3.003zm10.474-11.505h6.453c1.542 0 2.902.297 4.078.893 1.191.581 2.111 1.406 2.76 2.475.663 1.069.994 2.313.994 3.734 0 1.42-.331 2.665-.994 3.734-.649 1.068-1.569 1.9-2.76 2.495-1.176.582-2.536.873-4.078.873h-6.453v-14.204zm6.29 11.505c1.421 0 2.55-.392 3.389-1.177.852-.798 1.279-1.873 1.279-3.226s-.427-2.422-1.279-3.206c-.839-.798-1.968-1.198-3.389-1.198h-3.003v8.807h3.003zm20.888 2.943c-1.122 0-2.211-.149-3.267-.447-1.041-.311-1.88-.71-2.516-1.197l1.116-2.476c.609.447 1.333.805 2.172 1.076.838.27 1.677.406 2.516.406.933 0 1.623-.136 2.069-.406.447-.284.67-.656.67-1.116 0-.339-.135-.616-.406-.832-.257-.23-.595-.413-1.014-.548a19.473 19.473 0 00-1.664-.447c-1.082-.257-1.969-.514-2.658-.771a4.392 4.392 0 01-1.786-1.237c-.487-.569-.731-1.326-.731-2.273 0-.825.224-1.569.67-2.232.446-.677 1.116-1.211 2.009-1.603.906-.393 2.009-.589 3.307-.589.907 0 1.793.108 2.659.325.865.216 1.623.527 2.272.933l-1.014 2.496c-1.312-.744-2.625-1.116-3.937-1.116-.92 0-1.603.149-2.049.447-.433.297-.65.689-.65 1.176s.251.853.751 1.096c.514.23 1.292.46 2.334.69 1.082.257 1.968.514 2.658.771s1.278.663 1.765 1.218c.501.554.751 1.305.751 2.252 0 .812-.23 1.556-.69 2.232-.446.663-1.123 1.191-2.029 1.583-.906.392-2.009.589-3.308.589zm19.272-2.882v2.638h-10.999v-14.204h10.735v2.638h-7.468v3.084h6.595v2.557h-6.595v3.287h7.732zm11.665 2.638l-2.739-3.957h-3.024v3.957h-3.287v-14.204h6.149c1.258 0 2.347.209 3.267.629.933.419 1.65 1.014 2.151 1.785.5.772.75 1.685.75 2.74 0 1.055-.257 1.968-.771 2.739-.5.758-1.217 1.339-2.151 1.745l3.186 4.566h-3.531zm-.061-9.05c0-.798-.257-1.407-.771-1.826-.514-.433-1.264-.65-2.252-.65h-2.679v4.951h2.679c.988 0 1.738-.216 2.252-.649.514-.433.771-1.042.771-1.826zm19.589-5.154l-6.148 14.204h-3.247l-6.128-14.204h3.551l4.322 10.146 4.383-10.146h3.267zm12.184 11.566v2.638h-10.998v-14.204h10.735v2.638h-7.468v3.084h6.595v2.557h-6.595v3.287h7.731zm11.666 2.638l-2.739-3.957h-3.024v3.957h-3.287v-14.204h6.149c1.258 0 2.347.209 3.267.629.933.419 1.65 1.014 2.15 1.785.501.772.751 1.685.751 2.74 0 1.055-.257 1.968-.771 2.739-.5.758-1.217 1.339-2.151 1.745l3.186 4.566h-3.531zm-.061-9.05c0-.798-.257-1.407-.771-1.826-.514-.433-1.265-.65-2.252-.65h-2.679v4.951h2.679c.987 0 1.738-.216 2.252-.649.514-.433.771-1.042.771-1.826z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_2_svg__filter8_ii_104_85)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 235.902,
    width: 193.463,
    height: 67.073,
    rx: 5.073,
    fill: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#E1E1E1",
    strokeWidth: 1.268,
    d: "M10.149 246.66H182.68v45.556H10.149z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_2_svg__filter9_df_104_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.049 264.294h4.657c1.136 0 2.146.223 3.029.669a4.844 4.844 0 012.054 1.872c.487.802.73 1.73.73 2.785 0 1.056-.243 1.989-.73 2.801-.487.801-1.172 1.425-2.054 1.872-.883.436-1.893.654-3.029.654h-4.657v-10.653zm4.566 8.979c.78 0 1.466-.147 2.054-.441a3.22 3.22 0 001.37-1.279c.325-.558.487-1.202.487-1.933 0-.73-.162-1.369-.487-1.917a3.104 3.104 0 00-1.37-1.279c-.588-.304-1.273-.456-2.054-.456h-2.587v7.305h2.587zm8.008-8.979H41.6v10.653h-1.978v-10.653zm11.83 10.653l-2.177-3.12c-.09.01-.228.015-.41.015H46.46v3.105h-1.979v-10.653h4.383c.924 0 1.725.152 2.405.456.69.305 1.218.741 1.583 1.309s.548 1.243.548 2.024c0 .802-.198 1.492-.594 2.07-.385.578-.943 1.01-1.674 1.294l2.45 3.5h-2.13zm-.046-6.864c0-.679-.223-1.202-.67-1.567-.446-.366-1.1-.548-1.963-.548h-2.313v4.246h2.313c.863 0 1.517-.183 1.963-.548.447-.375.67-.903.67-1.583zm12.197 5.205v1.659h-7.99v-10.653h7.777v1.659h-5.798v2.769h5.144v1.629h-5.144v2.937h6.011zm7.092 1.811c-1.075 0-2.05-.233-2.922-.7a5.342 5.342 0 01-2.04-1.963c-.486-.832-.73-1.771-.73-2.816s.249-1.983.746-2.815a5.233 5.233 0 012.04-1.948c.872-.477 1.846-.715 2.921-.715.873 0 1.67.152 2.39.456.72.305 1.329.746 1.826 1.324l-1.278 1.202c-.772-.831-1.72-1.247-2.846-1.247-.73 0-1.385.162-1.964.487a3.393 3.393 0 00-1.354 1.324c-.325.568-.487 1.212-.487 1.932 0 .721.162 1.365.487 1.933a3.503 3.503 0 001.354 1.339c.579.315 1.233.472 1.964.472 1.126 0 2.075-.421 2.846-1.263l1.278 1.218a4.858 4.858 0 01-1.842 1.324c-.72.304-1.516.456-2.389.456zm8.169-9.131h-3.53v-1.674h9.04v1.674h-3.532v8.979h-1.978v-8.979zm16.13 9.131c-1.075 0-2.049-.233-2.921-.7a5.341 5.341 0 01-2.04-1.963c-.487-.832-.73-1.771-.73-2.816s.249-1.983.746-2.815a5.233 5.233 0 012.039-1.948c.873-.477 1.847-.715 2.922-.715.873 0 1.67.152 2.39.456.72.305 1.329.746 1.826 1.324l-1.279 1.202c-.77-.831-1.72-1.247-2.846-1.247-.73 0-1.385.162-1.963.487a3.392 3.392 0 00-1.354 1.324c-.325.568-.487 1.212-.487 1.932 0 .721.162 1.365.487 1.933a3.502 3.502 0 001.354 1.339c.579.315 1.233.472 1.963.472 1.127 0 2.075-.421 2.846-1.263l1.279 1.218a4.858 4.858 0 01-1.842 1.324c-.72.304-1.517.456-2.39.456zm10.881 0c-1.086 0-2.065-.233-2.937-.7a5.31 5.31 0 01-2.055-1.963c-.497-.842-.745-1.781-.745-2.816 0-1.034.248-1.968.745-2.8a5.17 5.17 0 012.055-1.963c.872-.477 1.851-.715 2.937-.715 1.086 0 2.065.238 2.937.715a5.203 5.203 0 012.055 1.948c.497.832.746 1.77.746 2.815s-.249 1.984-.746 2.816a5.31 5.31 0 01-2.055 1.963c-.872.467-1.851.7-2.937.7zm0-1.735c.71 0 1.35-.157 1.918-.472a3.536 3.536 0 001.339-1.339 3.874 3.874 0 00.487-1.933c0-.71-.162-1.349-.487-1.917a3.395 3.395 0 00-1.339-1.339c-.568-.325-1.208-.487-1.918-.487s-1.349.162-1.917.487a3.39 3.39 0 00-1.34 1.339 3.8 3.8 0 00-.487 1.917c0 .711.163 1.355.487 1.933a3.531 3.531 0 001.34 1.339c.568.315 1.207.472 1.917.472zm17.301-9.07v10.653h-1.628l-5.875-7.214v7.214h-1.963v-10.653h1.628l5.875 7.214v-7.214h1.963zm12.321 0v10.653h-1.629l-5.874-7.214v7.214h-1.963v-10.653h1.628l5.874 7.214v-7.214h1.964zm10.844 8.994v1.659h-7.99v-10.653h7.777v1.659h-5.798v2.769h5.144v1.629h-5.144v2.937h6.011zm7.092 1.811c-1.075 0-2.049-.233-2.922-.7a5.343 5.343 0 01-2.039-1.963c-.487-.832-.731-1.771-.731-2.816s.249-1.983.746-2.815a5.233 5.233 0 012.039-1.948c.873-.477 1.847-.715 2.922-.715.873 0 1.669.152 2.39.456.72.305 1.329.746 1.826 1.324l-1.278 1.202c-.771-.831-1.72-1.247-2.846-1.247-.731 0-1.385.162-1.964.487a3.395 3.395 0 00-1.354 1.324c-.325.568-.487 1.212-.487 1.932 0 .721.162 1.365.487 1.933a3.506 3.506 0 001.354 1.339c.579.315 1.233.472 1.964.472 1.126 0 2.075-.421 2.846-1.263l1.278 1.218a4.859 4.859 0 01-1.841 1.324c-.721.304-1.517.456-2.39.456zm8.169-9.131h-3.531v-1.674h9.04v1.674h-3.531v8.979h-1.978v-8.979z",
    fill: "#F8F8F8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_2_svg__filter0_ii_104_85",
    x: -7.609,
    y: 65.109,
    width: 407.219,
    height: 82.292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.609,
    dy: 7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_104_85"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.609,
    dy: -7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_104_85",
    result: "effect2_innerShadow_104_85"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_2_svg__filter1_d_104_85",
    x: 123.21,
    y: 100.028,
    width: 146.956,
    height: 16.984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.536
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_85"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_104_85",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_2_svg__filter2_ii_104_85",
    x: -7.609,
    y: -7.025,
    width: 407.219,
    height: 82.292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.609,
    dy: 7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_104_85"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.609,
    dy: -7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_104_85",
    result: "effect2_innerShadow_104_85"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_2_svg__filter3_df_104_85",
    x: 132.303,
    y: 23.756,
    width: 128.039,
    height: 16.031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.536
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_85"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_104_85",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.268,
    result: "effect2_foregroundBlur_104_85"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_2_svg__filter4_ii_104_85",
    x: -7.609,
    y: 137.244,
    width: 407.219,
    height: 82.292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.609,
    dy: 7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_104_85"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.609,
    dy: -7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_104_85",
    result: "effect2_innerShadow_104_85"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_2_svg__filter5_df_104_85",
    x: 112.696,
    y: 168.026,
    width: 167.636,
    height: 16.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.536
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_85"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_104_85",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.268,
    result: "effect2_foregroundBlur_104_85"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_2_svg__filter6_ii_104_85",
    x: 190.928,
    y: 228.293,
    width: 208.682,
    height: 82.292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.609,
    dy: 7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_104_85"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.609,
    dy: -7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_104_85",
    result: "effect2_innerShadow_104_85"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_2_svg__filter7_d_104_85",
    x: 225.183,
    y: 262.968,
    width: 139.191,
    height: 17.228,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.536
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_85"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_104_85",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_2_svg__filter8_ii_104_85",
    x: -7.609,
    y: 228.293,
    width: 208.682,
    height: 82.292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.609,
    dy: 7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_104_85"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.609,
    dy: -7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_104_85",
    result: "effect2_innerShadow_104_85"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_2_svg__filter9_df_104_85",
    x: 24.512,
    y: 261.605,
    width: 145.136,
    height: 16.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.536
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_85"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_104_85",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.268,
    result: "effect2_foregroundBlur_104_85"
  })))));
}
export default __webpack_public_path__ + "static/tutorial_2.733950ee.svg";
export { SvgTutorial2 as ReactComponent };